/* Alhana — storefront filtering UI (snippets/facets.liquid). Vanilla, no dependencies.
   The markup already works without JS (GET form + submit buttons); this adds:
   - sort select auto-submits; on the desktop sidebar, ticking a filter value submits too;
   - clean URLs (empty price boxes are dropped, min/max swapped when reversed) and a loading state;
   - below 990px the filter panel is a modal drawer (opened by theme.js [data-toggle-target]): dialog role,
     backdrop click closes, Tab stays inside, and the drawer's own sort select is the one submitted;
   - «اعرض الكل / اعرض أقل» for long value lists. */
(function () {
  "use strict";

  var desktop = window.matchMedia("(min-width: 990px)");
  var submitting = false;

  function navigate(form) {
    if (submitting) return;
    if (typeof form.reportValidity === "function" && !form.reportValidity()) return;

    var min = form.querySelector("[data-price-min]");
    var max = form.querySelector("[data-price-max]");
    if (min && max && min.value !== "" && max.value !== "" && Number(min.value) > Number(max.value)) {
      var low = max.value;
      max.value = min.value;
      min.value = low;
    }

    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (typeof value === "string" && value.trim() !== "") params.append(key, value.trim());
    });
    var query = params.toString();
    var action = form.getAttribute("action") || window.location.pathname;

    submitting = true;
    document.querySelectorAll("[data-facets-results]").forEach(function (el) {
      el.classList.add("is-loading");
      el.setAttribute("aria-busy", "true");
    });
    window.location.assign(action + (query ? "?" + query : ""));
  }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-facets-form]");
    if (!form) return;
    e.preventDefault();
    navigate(form);
  });

  document.addEventListener("change", function (e) {
    var target = e.target;

    // toolbar sort: always applies immediately
    if (target.matches("[data-facets-sort]")) {
      var drawerSort = document.querySelector("[data-facets-drawer-sort]");
      if (drawerSort) drawerSort.value = target.value;
      if (target.form) navigate(target.form);
      return;
    }
    // drawer sort (phones): keep the toolbar copy in step, apply with «اعرض النتايج»
    if (target.matches("[data-facets-drawer-sort]")) {
      var barSort = document.querySelector("[data-facets-sort]");
      if (barSort) barSort.value = target.value;
      return;
    }
    // sidebar (desktop): a ticked value applies at once; prices wait for Enter / «طبّق»
    // (submitting on blur would fire while moving from «من» to «لـ»)
    var form = target.closest("[data-facets-form]");
    if (form && desktop.matches && target.type === "checkbox") navigate(form);
  });

  // «اعرض الكل» / «اعرض أقل»
  document.addEventListener("click", function (e) {
    var button = e.target.closest("[data-facets-more]");
    if (!button) return;
    var list = document.getElementById(button.getAttribute("aria-controls"));
    if (!list) return;
    var expanded = button.getAttribute("aria-expanded") !== "true";
    button.setAttribute("aria-expanded", String(expanded));
    list.classList.toggle("is-expanded", expanded);
    button.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
  });

  // backdrop click closes the drawer (through its close button, so theme.js restores focus)
  document.addEventListener("click", function (e) {
    var drawer = e.target.closest("[data-facets-drawer]");
    if (!drawer || e.target !== drawer || !drawer.classList.contains("is-open")) return;
    var close = drawer.querySelector("[data-toggle-close]");
    if (close) close.click();
  });

  // keep Tab inside the open drawer (Escape and the close button still leave it)
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Tab" || desktop.matches) return;
    var drawer = document.querySelector("[data-facets-drawer].is-open");
    if (!drawer) return;
    var items = Array.prototype.filter.call(
      drawer.querySelectorAll("a[href], button:not([disabled]), input:not([disabled]):not([type='hidden']), select:not([disabled]), summary"),
      function (el) { return el.getClientRects().length > 0; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
      e.preventDefault();
      first.focus();
    }
  });

  // sidebar ≥990px, modal drawer below; only one of the two sort selects is ever submitted
  function sync() {
    var isDesktop = desktop.matches;
    document.querySelectorAll("[data-facets-drawer]").forEach(function (drawer) {
      if (isDesktop) {
        drawer.removeAttribute("aria-modal");
        drawer.setAttribute("role", "region");
        drawer.hidden = false;
        if (drawer.classList.contains("is-open")) {
          drawer.classList.remove("is-open");
          document.documentElement.classList.remove("has-panel-open");
          document.querySelectorAll('[data-toggle-target="' + drawer.id + '"]').forEach(function (b) {
            b.setAttribute("aria-expanded", "false");
          });
        }
      } else {
        drawer.setAttribute("role", "dialog");
        drawer.setAttribute("aria-modal", "true");
      }

      var form = drawer.querySelector("[data-facets-form]");
      var drawerSort = drawer.querySelector("[data-facets-drawer-sort]");
      var barSort = form ? document.querySelector('[data-facets-sort][form="' + form.id + '"]') : null;
      if (drawerSort && barSort) {
        drawerSort.disabled = isDesktop;
        barSort.disabled = !isDesktop;
      }
    });
  }

  sync();
  if (typeof desktop.addEventListener === "function") desktop.addEventListener("change", sync);
  else if (typeof desktop.addListener === "function") desktop.addListener(sync);

  // coming back with the browser's back button (bfcache): drop the loading state
  window.addEventListener("pageshow", function () {
    submitting = false;
    document.querySelectorAll("[data-facets-results].is-loading").forEach(function (el) {
      el.classList.remove("is-loading");
      el.removeAttribute("aria-busy");
    });
  });
})();
